import { CSS } from '@stitches/react';

export interface DateRangeDropdownProps {
  buttonStyles?: CSS;
  css?: CSS;
  dateRangeErrorDescription?: string;
  dateRangeErrorTitle?: string;
  maxDate?: Date;
  minDate?: Date;
  onSelect: (dateRange: DateRangeSelection) => void;
  showText?: boolean;
  value?: DateRangeSelection | undefined;
  layout: number;
}

export interface DateRangeSelection {
  startDate: Date | undefined;
  endDate: Date | undefined;
  selectedDateRange: DateRangeOptionId;
}

export enum DateRangeOptionId {
  THIS_WEEK = 'this_week',
  THIS_MONTH = 'this_month',
  LAST_MONTH = 'last_month',
  THIS_YEAR = 'this_year',
  ALL_TIME = 'all_time',
  CUSTOM = 'custom_range',
  THIS_QUARTER = 'this_quarter',
  LAST_QUARTER = 'last_quarter',
  LAST_YEAR = 'last_year',
}
